import React from "react";
// 引入编辑器组件
import BraftEditor from "braft-editor";
// 引入编辑器样式
import "braft-editor/dist/index.css";
import API from '@/api'

class EditorDemo extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      // 创建一个空的editorState作为初始值
      editorState: BraftEditor.createEditorState(null),
    };
  }

  saveEditorContent() {
    return true;
  }

  async initDetail(htmlContent) {
    // 使用BraftEditor.createEditorState将html字符串转换为编辑器需要的editorStat
    this.setState({
      editorState: BraftEditor.createEditorState(htmlContent),
    });
  }

  submitContent = async () => {
    // 在编辑器获得焦点时按下ctrl+s会执行此方法
    // 编辑器内容提交到服务端之前，可直接调用editorState.toHTML()来获取HTML格式的内容
    const htmlContent = this.state.editorState.toHTML();
    const result = await this.saveEditorContent(htmlContent);
    console.log('result', result)
  };

  handleEditorChange = (editorState) => {
    this.setState({ editorState }, this.props.onChange(editorState.toHTML()));
  };

  getUploadParams = async file => {
    const res = await API.GetOssPostObjectParams({
      path: 'article'
    })
    if (res.code !== 200) return
    const { result: params } = res

    const fileType = file.name.split('.').pop()
    const key = `${params.fileName}.${fileType}`
    const policy = params.policy
    const ossAccessKeyId = params.OSSAccessKeyId
    const signature = params.signature

    const formData = {
      key,
      policy,
      OSSAccessKeyId: ossAccessKeyId,
      signature
    }

    return {
      uploadUrl: params.host,
      formData,
      imgUrl: `http://public.nuiii.com/${formData.key}`
    }
  }

  uploadFn = async (param) => {
    const { uploadUrl, formData, imgUrl } = await this.getUploadParams(param.file)

    const serverURL = uploadUrl
    const xhr = new XMLHttpRequest
    const fd = new FormData()
  
    const successFn = (response) => {
      // 假设服务端直接返回文件上传后的地址
      // 上传成功后调用param.success并传入上传后的文件地址
      param.success({
        url: imgUrl,
        meta: {
          id: imgUrl,
          title: param.file.name,
          alt: param.file.name,
          loop: true, // 指定音视频是否循环播放
          autoPlay: true, // 指定音视频是否自动播放
          controls: true, // 指定音视频是否显示控制栏
          poster: uploadUrl, // 指定视频播放器的封面
        }
      })
    }
  
    const progressFn = (event) => {
      // 上传进度发生变化时调用param.progress
      param.progress(event.loaded / event.total * 100)
    }
  
    const errorFn = (response) => {
      // 上传发生错误时调用param.error
      param.error({
        msg: 'unable to upload.'
      })
    }
  
    xhr.upload.addEventListener("progress", progressFn, false)
    xhr.addEventListener("load", successFn, false)
    xhr.addEventListener("error", errorFn, false)
    xhr.addEventListener("abort", errorFn, false)
  
    fd.append('key', formData.key)
    fd.append('policy', formData.policy)
    fd.append('OSSAccessKeyId', formData.OSSAccessKeyId)
    fd.append('signature', formData.signature)

    fd.append('file', param.file)
    
    xhr.open('POST', serverURL, true)
    xhr.send(fd)

  }

  render() {
    const { editorState } = this.state;
    return (
      <div className="my-component">
        <BraftEditor
          value={editorState}
          onChange={this.handleEditorChange}
          onSave={this.submitContent}
          media={{ uploadFn: this.uploadFn }}
        />
      </div>
    );
  }
}

export default EditorDemo;
